import React from 'react';

/**
 * Shell for a single step in the vertical course path (timeline node + the
 * connector line + the step content). Used to stack video / exercise / result
 * blocks top-to-bottom so the user is guided through the course step by step.
 *
 * status: 'done' | 'active' | 'todo'
 */
const CourseStep = ({ status = 'todo', icon, isLast = false, id, children }) => {
  return (
    <div className="ac-step" id={id}>
      <div className="ac-step-rail">
        <div className={`ac-step-node is-${status}`}>{icon}</div>
        {!isLast && <div className="ac-step-line" />}
      </div>
      <div className="ac-step-content">{children}</div>
    </div>
  );
};

export default CourseStep;
